import React, { useEffect, useState } from "react";
import { useAsync } from "../../async";
import { Button, Popover, Box, CircularProgress } from "@material-ui/core";
import { medsUserApi } from "../../../../services/medicationmanagement/medsUser/MedsUserApi";
import { ReactComponent as HealthcareProviderIcon } from "../../../../images/HealthcareProviderIcon.svg";
import { ReactComponent as PopoverButtonUp } from "../../../../images/PopoverButtonUp.svg";
import { ReactComponent as PopoverButtonDown } from "../../../../images/PopoverButtonDown.svg";
import styles from './PractitionerHpiiDetails.module.scss';

export interface IHpiiDetailsProps {
    encounterAuthoringSystem: string,
    encounterAuthoringSystemForeignKey: string
}

export const GetPractitionerHpiiDetails = async (encounterAuthoringSystem: string, encounterAuthoringSystemForeignKey: string) => {
    return await medsUserApi.getUserHpiiForFacility(encounterAuthoringSystem, encounterAuthoringSystemForeignKey);
}

export const PractitionerHpiiDetails = (props: IHpiiDetailsProps) => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [popoverWidth, setPopoverWidth] = React.useState(0);
    let { inProgress, success:practitionerHpii, error, queryDispatcher } = useAsync();

    useEffect(() => {
        queryDispatcher(GetPractitionerHpiiDetails(props.encounterAuthoringSystem, props.encounterAuthoringSystemForeignKey));
    }, []);

    const handleClick = (event: any) => {
        setPopoverWidth(event.currentTarget?.offsetWidth);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'hpii-popover' : undefined;
    const buttonEndIcon = open ? <PopoverButtonUp /> : <PopoverButtonDown />;

    const formatHpii = (hpiiNumber: string | null): string => {
        var maskingString = '____';
        var segments = hpiiNumber?.match(/.{1,4}/g);
        if (hpiiNumber?.length === 0 || segments == null) return "";

        if (practitionerHpii.hpiiStatus?.toLowerCase() == "invalid") {
            segments.splice(1, 3, maskingString, maskingString, maskingString);
        }
        return segments.join(' ');
    }

    if (inProgress) {
        return (
            <CircularProgress
                style={{
                    color: "var(--dna-alias-color-primary)",
                    marginRight: "20px"
                }}
                size={30}
            />
        );
    }

    return (
        <React.Fragment>
            <Button id="hpiiPopoverButton" className={styles.hpiiButton} aria-describedby={id} variant={"outlined"} startIcon={<HealthcareProviderIcon />} onClick={handleClick} endIcon={buttonEndIcon}>
                Practitioner HPI-I details{practitionerHpii?.hpiiStatus?.toLowerCase() == "invalid" &&
                    <span className={styles.invalidHpii}>&nbsp;– Check details with facility</span>
                }
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                PaperProps={{
                    style: { minWidth: popoverWidth }
                }}
            >
                <Box id="popoverBox" className={styles.popoverContainer}>
                    <Box className={styles.popoverRow}>
                        <span className={styles.label}>HPI-I status</span> {" "} <span className={practitionerHpii?.hpiiStatus?.toLowerCase() == "invalid" ? styles.invalidHpii : styles.data}>{practitionerHpii?.hpiiStatus}</span>
                    </Box>
                    <Box className={styles.popoverRow}>
                        <span className={styles.label}>First name</span> {" "} <span className={styles.data}>{practitionerHpii?.givenName}</span>
                    </Box>
                    <Box className={styles.popoverRow}>
                        <span className={styles.label}>Last name</span> {" "} <span className={styles.data}>{practitionerHpii?.familyName}</span>
                    </Box>
                    <Box className={styles.popoverRow}>
                        <span className={styles.label}>HPI-I number</span> {" "} <span className={styles.data}>{formatHpii(practitionerHpii?.hpiiNumber)}</span>
                    </Box>
                </Box>
            </Popover>
        </React.Fragment>
    );
};
